export default {
  craft: {
    validation: {
      key: {
        already_used: 'This key is already taken.',
      },
      duns: {
        already_used: 'DUNS is already used by %{id}',
      },
      siren_code: {
        already_used: 'SIREN is already used by %{id}',
      },
    },
  },
};
